import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { verifyUser } from '../services/fetch_api'; // Import the new method

function VerifyUser() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Verifying...');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const hasVerified = useRef(false);

  useEffect(() => {
    // console.log('VerifyUser component mounted with token:', token);
    // console.log('hasVerified.current:', hasVerified.current);

    if (!token) {
      setMessage('No verification token provided.');
      setIsLoading(false);
      return;
    }

    // Prevent multiple verification attempts
    if (hasVerified.current) {
      // console.log('Verification already attempted, skipping...');
      return;
    }

    hasVerified.current = true;
    setIsLoading(true);

    verifyUser(token)
      .then((response) => {
        // console.log('Verification successful:', response);
        setMessage('Verification successful!');
        setError(null);

        // Start countdown and redirect after 5 seconds
        let timeLeft = 5;
        setCountdown(timeLeft);

        const countdownInterval = setInterval(() => {
          timeLeft--;
          setCountdown(timeLeft);

          if (timeLeft <= 0) {
            clearInterval(countdownInterval);
            navigate('/login');
          }
        }, 1000);
      })
      .catch((error) => {
        console.error('Verification failed:', error);
        setError(error);
        setMessage(`Verification failed: ${error.message}`);
      })
      .finally(() => {
        setIsLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array - run only once on mount to prevent multiple verification attempts

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>{message}</h1>
      {isLoading && <p>Please wait...</p>}
      {error && (
        <div style={{ color: 'red', marginTop: '10px' }}>
          <p>
            <strong>Error Details:</strong>
          </p>
          <p>{error.message}</p>
          <p>
            <strong>Token:</strong> {token}
          </p>
        </div>
      )}
      {!isLoading && !error && (
        <div style={{ color: 'green' }}>
          <p>Email verification completed successfully!</p>
          {countdown !== null && (
            <p>
              Redirecting to login page in {countdown} second
              {countdown !== 1 ? 's' : ''}...
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default VerifyUser;
